import styled, { css } from 'styled-components'
import FontAwesome from 'react-fontawesome'

const Container = styled.div`
  background: var(--white);
  border-right: 1px solid var(--main-color);
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  width: 30%;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  ${(props) =>
    props.position === 'window' &&
    css`
      width: 100%;
    `}

  ${(props) =>
    props.position === 'right' &&
    css`
      right: 0;
      left: auto;
      border-left: 1px solid var(--main-color);
    `}
`

const Buttons = styled.div`
  text-align: right;
  padding: 5px;
  background: #f8f8f8;
  border-bottom: 1px solid #eeeeee;

  > span {
    line-height: 30px;
    font-size: 16px;
    font-weight: bold;
  }
  button {
    padding: 0;
    margin: 0;
    color: var(--main-color);
    background: none;
    border: none;
    font-size: 18px;
    margin: 3px;
    &:disabled {
      color: #5b5b5b;
    }
    &:last-child {
      margin-left: 5px;
    }
  }
`

const Text = styled.textarea`
  width: 100%;
  height: 100%;
  border: none;
  padding: 5px;
`

const Notes = ({
  position,
  changePosition,
  handleChange,
  value,
  handleBlur
}) => {
  return (
    <Container position={position}>
      <Buttons>
        <span className="pull-left">Notes</span>
        <button
          type="button"
          onClick={changePosition.bind(null, 'left')}
          disabled={position === 'left'}
          title="Dock left"
        >
          <FontAwesome name="toggle-left" />
        </button>
        <button
          type="button"
          onClick={changePosition.bind(null, 'right')}
          disabled={position === 'right'}
          title="Dock right"
        >
          <FontAwesome name="toggle-right" />
        </button>
        <button
          type="button"
          onClick={changePosition.bind(null, 'window')}
          disabled={position === 'window'}
          title="Undock into separate window"
        >
          <FontAwesome name="window-maximize" />
        </button>
        <button type="button" onClick={changePosition.bind(null, '')}>
          <FontAwesome name="window-close-o" />
        </button>
      </Buttons>
      <Text
        onChange={handleChange}
        value={value}
        onBlur={handleBlur}
        placeholder="Start typing your notes here and they will be save automatically"
      />
    </Container>
  )
}

export default Notes
